import { createContext, useContext } from "react";

/** Iter 159 — Textos de la página pública en el idioma del cliente (fallback ES embebido). */
export const DEFAULT_TEXTS = {
  title: "Presupuesto de reparación", state_pending: "Pendiente de tu respuesta", state_accepted: "Aceptado",
  state_rejected: "Rechazado", state_expired: "Caducado", repair_no: "Nº reparación", customer: "Cliente",
  device: "Equipo", model: "Modelo", serial: "Nº de serie", date: "Fecha", validity: "Validez",
  valid_until: "Hasta el {{fecha}}", diagnosis: "Diagnóstico",
  your_repair: "Tu reparación", lines_intro: "Estas son las líneas que forman parte de tu presupuesto.",
  warranty_months: "Garantía {{n}} meses", no_lines: "Sin líneas en el presupuesto.", repair_total: "Total reparación (IVA incluido)",
  addons_title: "También te puede interesar",
  addons_intro: "Extras opcionales para tu equipo. No forman parte del presupuesto salvo que los añadas.",
  months: "{{n}} meses", available: "Disponible", unavailable: "Actualmente no disponible", add: "Añadir", added: "Añadido", remove: "Quitar",
  original_quote: "Presupuesto original", selected_extras: "Extras seleccionados", extras_total: "Total extras",
  total_vat: "Total (IVA incluido)", extras_count: "{{n}} extra(s)", accept: "Aceptar presupuesto", reject: "Rechazar presupuesto",
  confirm_title: "Confirmar presupuesto", confirm_intro: "Revisa el resumen final antes de confirmar.", confirm_submit: "Confirmar presupuesto",
  reject_title: "Rechazar presupuesto", reject_question: "¿Seguro que quieres rechazar este presupuesto?",
  reject_intro: "No se realizará ninguna reparación ni se procesará ningún extra seleccionado. Puedes contactarnos si necesitas un presupuesto distinto.",
  reject_submit: "Sí, rechazar", cancel: "Cancelar", processing: "Procesando…", close: "Cerrar",
  accepted_title: "Presupuesto aceptado", accepted_text: "Aceptado el {{fecha}}. ¡Gracias por confiar en nosotros!",
  accepted_toast: "Presupuesto aceptado. ¡Gracias!", accepted_lines: "Líneas aceptadas", skipped_title: "Extras no disponibles",
  skipped_text: "Te contactaremos para confirmarlo.", rejected_title: "Presupuesto rechazado",
  rejected_text: "Rechazado el {{fecha}}. Si cambias de opinión, ponte en contacto con nosotros.", rejected_toast: "Presupuesto rechazado.",
  expired_title: "Presupuesto no disponible",
  expired_text: "Este presupuesto ya no está disponible para aceptación. Contacta con nosotros para recibir un presupuesto actualizado.",
  loading: "Cargando presupuesto…", link_unavailable: "Enlace no disponible", err_invalid_link: "Este enlace no es válido o ha sido revocado.",
  err_already: "Este presupuesto ya ha sido respondido.", err_addon_unavailable: "Uno de los extras seleccionados ya no está disponible. Revisa tu selección.",
  err_generic: "Ha ocurrido un error. Inténtalo de nuevo.",
};

export const PublicI18nContext = createContext({ texts: DEFAULT_TEXTS, locale: "es-ES" });

export function makeT(texts) {
  return (key, vars = {}) => {
    let s = (texts && texts[key]) || DEFAULT_TEXTS[key] || key;
    Object.entries(vars).forEach(([k, v]) => { s = s.split(`{{${k}}}`).join(String(v)); });
    return s;
  };
}

export function useT() {
  const { texts, locale } = useContext(PublicI18nContext);
  return { t: makeT(texts), locale };
}
